export const UserTypes = {
  Driver: "Driver",
  Merchant: "Merchant",
  Consumer: "Customer",
};

export const QueryTypes = {
  OrderId: "order_id",
};

export const OrderCategories = {
  Food: "FOOD",
  Blinkit: "BLINKIT",
};

export const LifelineURLs = {
  Zomato: "https://admin.zomans.com/lifeline?",
  Blinkit: "https://lifeline.blinkit.com/lifeline?",
};
